import { useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { PageHeader, Panel } from "@/components/app/PageParts";
import { AccountForm } from "@/components/app/AccountForm";
import { IntegrationStatus } from "@/components/app/IntegrationStatus";
import { NotificationPrefs } from "@/components/app/NotificationPrefs";
import { ResetSampleButton } from "@/components/app/SampleBanner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function Settings() {
  const { workspace, reloadWorkspace } = useOutletContext();
  const { user } = useAuth();
  const initial = { name: workspace.name, account_type: workspace.account_type || "", business_name: workspace.business_name, timezone: workspace.timezone };

  const save = async (form) => {
    await api.patch(`/workspaces/${workspace.id}`, form);
    toast.success("Workspace details saved");
    reloadWorkspace();
  };

  return (
    <div data-testid="settings-page">
      <PageHeader eyebrow="Settings" title="Workspace settings" />
      <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr]">
        <Panel title="Workspace details" testId="settings-company-panel">
          <div className="p-5 sm:p-6">
            {workspace.is_sample && <p className="mb-4 text-sm text-slate-500" data-testid="settings-sample-readonly">Sample details can't be edited.</p>}
            {!workspace.account_type && !workspace.is_sample && <p className="mb-4 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="settings-choose-role">Please choose homeowner or real estate agent for this workspace.</p>}
            <AccountForm key={workspace.id} initial={initial} onSubmit={save} submitLabel="Save changes" disabled={workspace.is_sample} />
          </div>
        </Panel>
        <div className="space-y-6">
          <Panel title="Your account" testId="settings-account-panel">
            <dl className="space-y-3 p-5 text-sm">
              <div><dt className="text-slate-500">Name</dt><dd className="font-medium text-navy" data-testid="settings-account-name">{user.name}</dd></div>
              <div><dt className="text-slate-500">Email</dt><dd className="font-medium text-navy" data-testid="settings-account-email">{user.email}</dd></div>
              <div><dt className="text-slate-500">Email status</dt><dd className="font-medium text-emerald-700">Confirmed</dd></div>
            </dl>
          </Panel>
          <NotificationPrefs />
          {workspace.is_sample && (
            <Panel title="Sample workspace" testId="settings-sample-panel">
              <div className="p-5 text-sm text-slate-600">
                <p>Put the practice records back to how they started.</p>
                <ResetSampleButton workspace={workspace} label="Reset sample workspace" className="mt-4 rounded-md bg-navy px-4 py-2 text-sm font-medium text-white hover:bg-navy-2" />
              </div>
            </Panel>
          )}
        </div>
      </div>
      <div className="mt-8">
        <h2 className="mb-3 font-display text-base font-semibold text-navy">Services</h2>
        <IntegrationStatus />
      </div>
    </div>
  );
}
